// extracted by mini-css-extract-plugin
export var askAiIcon = "_s4-9";
export var container = "_s4-0";
export var groupSeparator = "_s4-a";
export var highlight = "_s4-4";
export var resultIcon = "_s4-5";
export var resultItem = "_s4-7";
export var resultSubtitle = "_s4-3";
export var resultTitle = "_s4-2";
export var resultsList = "_s4-1";
export var searchGroup = "_s4-6";
export var selected = "_s4-8";